import React, { useState, useEffect } from "react";
import { Modal, Form, Tabs, Tab, Button, Dropdown } from "react-bootstrap";
import commonApi from "../../CommonApi/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { payment_status } from "../../Redux/PricingAction";
import { loadStripe } from "@stripe/stripe-js";
import {
  getMonthName,
  getPlanMessage,
  stringToInt,
  stripe_promise,
} from "../../constant/commonUtils";

import StripePaymentForm from "../tabs/StripePaymentForm";
import { Elements } from "@stripe/react-stripe-js";
// import BillingAdressModal from "./BillingAdressModal";
import StripeSubscriptionForm from "../tabs/StripeSubscriptionForm";
import { CheckCircle, XCircle } from "lucide-react";
import SpinnerLoader from "../../webLoader/SpinnerLoader";
import { errorMessage, successMessage } from "../../Errors/Toast";

const stripePromise = loadStripe(stripe_promise());

const PricingModal = (props) => {
  const [pricing_detail, setPricing_detail] = useState([]);
  const [client_secret, setClient_secret] = useState("");
  const [showError, setShowError] = useState("");
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [confirmationData, setConfirmationData] = useState({});

  const [key, setKey] = useState("Premium");
  const [modelType, setModelType] = useState("");
  const [selectedPkg, setSelectedPkg] = useState({});
  const pricingSelector = useSelector((state) => state.rootReducer);
  const profileSelector = useSelector((state) => state.profileReducer);
  const [dropdownId, setdropdownId] = useState("");
  const [dropdownValues, setDropdownValues] = useState([]);

  const history = useNavigate();

  const dispatch = useDispatch();

  const tokenSelector = useSelector((state) => state.rootReducer?.user?.token);

  const user_type = useSelector((state) => state.payment_reducer);
  const seletedPkg = user_type?.type?.type;

  useEffect(() => {
    if (props.show) {
      get_pricing_packages();
    } else {
      setPricing_detail([]);
    }
    // eslint-disable-next-line
  }, [props.show]);

  const get_pricing_packages = () => {
    commonApi
      .get_packages("", tokenSelector)
      .then((res) => {
        if (res.status === 200 && res.success) {
          const packages = res?.questions || [];
          setPricing_detail(packages);

          const hasPremium = packages.some((pkg) => pkg.name === "Premium");
          const hasPro = packages.some((pkg) => pkg.name === "Pro");

          if (hasPremium) {
            setKey("Premium");
          } else if (hasPro) {
            setKey("Pro");
          } else {
            setKey("Basic"); // optional fallback
          }
        }
      })
      .catch((err) => {
        console.log("Err", err);
        return { type: "error", message: err.message };
      });
  };

  const get_payment_method = () => {
    commonApi
      .get_payment_method("", tokenSelector)
      .then((res) => {
        if (res.success === true) {
          setDropdownValues(res?.cards);
          const defaultCard = res?.cards.find((card) => card.is_default);
          if (defaultCard) {
            setdropdownId(defaultCard.id); // or use `payment_method` key if that's what you use
          }
          setShowLoader(false);
        } else {
          setDropdownValues([]);
          setdropdownId("");
          setShowLoader(false);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        console.log("Err", err);
        return { type: "error", message: err.message };
      });
  };

  const create_subscription = (package_id) => {
    const formData = new FormData();
    formData.append("package_id", package_id);
    formData.append("card_id", dropdownId ? dropdownId : "");

    commonApi
      .create_subscription(formData, tokenSelector)
      .then((res) => {
        if (res.status === 200 && res.success === true) {
          if (res?.client_secret) {
            setClient_secret(res?.client_secret);
            setSubscriptionId(res?.subscription_id);
            setShowLoader(false);
          } else {
            // setModelType("show_success");
            setShowError(res.message);
            setShowLoader(false);
          }
        } else {
          setShowLoader(false);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        setShowLoader(false);

        return { type: "error", message: err.message };
      });
  };

  const handleClose = () => {
    if (pricingSelector?.user?.payment_status === true) {
      props.setShowModel(false);
      // history("/journey");
    } else {
      // history("/playground");
      props.setShowModel(false);
    }
  };

  const handleGetStarted = (type, data) => {
    if (type === "confirmation") {
      setShowLoader(true);
      if (data?.requires_instant_payment) {
        get_payment_method();
      } else {
        setTimeout(() => {
          setShowLoader(false);
        }, 100);
      }
      setConfirmationData({
        ...data,
        hasSavedCard:
          profileSelector?.profileData?.payment_methods?.length > 0
            ? true
            : false,
        packageData: data,
      });
      setModelType("stripe");
    } else {
      setSelectedPkg({
        grade: data.grade,
        id: data.package_id,
        price: data.price,
        type: data.name,
        package_id: data.package_id,
        description: data.description,
      });
      dispatch(
        payment_status(
          data.grade,
          data.package_id,
          data.price,
          data.name,
          data.package_id
        )
      );
      setShowLoader(true);
      create_subscription(data.package_id);
      setConfirmationData({});
    }
  };

  const Basic = pricing_detail?.filter((item) => item.name === "Basic");
  const Pro = pricing_detail?.filter((item) => item.name === "Pro");

  const Premium = pricing_detail?.filter((item) => item.name === "Premium");

  const messages = {
    upgrade: "🚀 Upgrade to unlock full features!",
    resume: "📝 Please upgrade to access the Resume Builder.",
    sidebar: "⚡ Upgrade to increase your limits.",
    agent: "🎙️ Unlock AI Voice feature by upgrading.",
    story: "⚠️ Insufficient token. Upgrade to create unlimited AI Stories.",
  };

  return (
    <>
      {modelType === "" && pricing_detail?.length > 0 && (
        <Modal
          id="pricing-modal"
          className={"custom-modal1"}
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            {/* <div
            // className={!Basic ||
            //   !Basic?.length > 0 && "Pro-tab"}
            > */}
            <h2>Pricing</h2>
            <i className="fa-solid fa-xmark" onClick={handleClose}></i>
            {/* </div> */}
          </Modal.Header>

          <Modal.Body>
            {props.source && (
              <div className={`pricing-banner-wrapper ${props.source} mt-3`}>
                <div className="pricing-banner-content">
                  <span>{messages[props.source]}</span>
                </div>
              </div>
            )}

            <Form noValidate className="custom-form-modal">
              <div className="pricing-info-block">
                <div className="modal-tab-block"></div>

                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                >
                  {pricing_detail &&
                    pricing_detail?.length > 0 &&
                    pricing_detail.map((item, index) => (
                      <Tab
                        eventKey={item.name}
                        key={index}
                        title={
                          <div>
                            <span>{item.name}</span>
                          </div>
                        }
                      >
                        <div className="payment-tab-holder">
                          <div className="payment-tab-content">
                            <div className="payment-list-box">
                              <h3>Included</h3>
                              <ul className="list-unstyled">
                                <li>{item.description?.access}</li>
                                <li>{item.description?.playground}</li>
                                <li>{item.description?.analysis}</li>
                                <li>{item.description?.activity}</li>
                                <li>{item.description?.award}</li>
                                <li>{item.description?.college}</li>
                                <li>{item.description?.resume_builder}</li>
                                {item.prorated_amount && (
                                  <li
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <h4 className="mb-0">
                                      Prorated for{" "}
                                      {new Date().toLocaleString("default", {
                                        month: "long",
                                      })}
                                      :{" "}
                                    </h4>
                                    <span
                                      style={{
                                        marginLeft: "3px",
                                        marginBottom: "0px",
                                        color: "black",
                                      }}
                                    >
                                      ${item.prorated_amount}
                                    </span>
                                  </li>
                                )}
                              </ul>
                              <div className="dollar-list-contain">
                                <strong>
                                  {item.price == 0.0
                                    ? "Free"
                                    : `$${item.price}/mo`}
                                </strong>
                                <button
                                  className="btn btn-primary landing-custom-btn"
                                  onClick={() => {
                                    handleGetStarted("confirmation", item);
                                  }}
                                >
                                  Select Plan
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                    ))}
                </Tabs>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      )}
      {modelType === "stripe" && (
        <Modal
          id="join-modal"
          className="custom-modal1 custom-modal2 custom-modal3"
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header style={{ marginBottom: "2px" }}>
            <i
              className="fa-solid fa-xmark"
              onClick={() => {
                if (
                  confirmationData &&
                  Object.entries(confirmationData)?.length > 0
                ) {
                  setConfirmationData({});
                  setModelType("");
                } else if (showError) {
                  props.onCloseHitApi();
                } else if (client_secret) {
                  handleClose();
                }
              }}
            ></i>
          </Modal.Header>

          <Modal.Body className="mt-2">
            {showLoader && (
              <div className="d-flex align-items-center justify-content-center">
                {showLoader && <SpinnerLoader color="white" />}
              </div>
            )}
            {!showLoader &&
            confirmationData &&
            Object.entries(confirmationData)?.length > 0 ? (
              <div className="d-flex align-items-center justify-content-center">
                <div className="text-center">
                  <h2
                    style={{ color: "#54aad6" }}
                    className="text-2xl font-bold mb-2 text-gray-800 mb-4"
                  >
                    Confirm Plan Selection
                  </h2>
                  {confirmationData?.packageData?.requires_instant_payment &&
                    dropdownValues?.length > 0 && (
                      <div className="form-group m-4">
                        <div className="form-group-contain">
                          <div className="custom-form-slect-field">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                              >
                                {dropdownId &&
                                  (() => {
                                    const selected = dropdownValues.find(
                                      (item) => item.id === dropdownId
                                    );
                                    if (!selected) return "Select Card";

                                    const brand =
                                      selected?.brand?.charAt(0).toUpperCase() +
                                      selected?.brand?.slice(1).toLowerCase();

                                    const last4 = selected?.last4 || "0000";
                                    const expMonth = selected?.exp_month;
                                    const expYear = selected?.exp_year;

                                    const formattedDate =
                                      expMonth && expYear
                                        ? `Expires ${getMonthName(
                                            expMonth
                                          )} ${expYear}`
                                        : "";

                                    return `${brand} •••• ${last4} - ${formattedDate}`;
                                  })()}
                              </Dropdown.Toggle>

                              <Dropdown.Menu className="scrollable-dropdown">
                                {dropdownValues.map((item, index) => {
                                  const brand =
                                    item?.brand?.charAt(0).toUpperCase() +
                                    item?.brand?.slice(1).toLowerCase();

                                  const last4 = item?.last4 || "0000";
                                  const expMonth = item?.exp_month;
                                  const expYear = item?.exp_year;

                                  const formattedDate =
                                    expMonth && expYear
                                      ? `Expires ${getMonthName(
                                          expMonth
                                        )} ${expYear}`
                                      : "";

                                  return (
                                    <Dropdown.Item
                                      key={index}
                                      onClick={() => {
                                        setdropdownId(item.id);
                                      }}
                                    >
                                      {brand} •••• {last4} - {formattedDate}
                                    </Dropdown.Item>
                                  );
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    )}

                  {getPlanMessage(
                    profileSelector?.profileData?.subscription,
                    confirmationData?.packageData
                  )
                    .split("\n")
                    .map((line, idx) => (
                      <p key={idx}>{line}</p>
                    ))}

                  {confirmationData?.hasSavedCard &&
                    confirmationData?.packageData?.price !== "0.00" &&
                    profileSelector?.profileData?.subscription?.price !==
                      confirmationData?.packageData?.price &&
                    dropdownValues?.length > 0 && (
                      <p>We will charge your saved card automatically.</p>
                    )}
                </div>
              </div>
            ) : !showLoader && client_secret ? (
              <div className="row">
                <div className="col-md-6">
                  <div className="payment-tab-content">
                    <div
                      style={{
                        boxShadow: "none",
                        border: "none",
                        paddingTop: "0px",
                        minHeight: "340px",
                      }}
                      className="payment-list-box"
                    >
                      <h3>Included</h3>
                      <ul className="list-unstyled">
                        <li>{selectedPkg.description?.access}</li>
                        <li>{selectedPkg.description?.playground}</li>
                        <li>{selectedPkg.description?.analysis}</li>
                        <li>{selectedPkg.description?.activity}</li>
                        <li>{selectedPkg.description?.award}</li>
                        <li>{selectedPkg.description?.college}</li>
                        <li>{selectedPkg.description?.resume_builder}</li>
                      </ul>
                      <div className="dollar-list-contain">
                        <strong>${selectedPkg.price}/mo</strong>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  {client_secret && (
                    <Elements
                      stripe={stripePromise}
                      options={{
                        clientSecret: client_secret,
                      }}
                    >
                      <StripeSubscriptionForm
                        subscriptionId={subscriptionId}
                        onClose={(type) => {
                          if (type === "success") {
                            setModelType("show_success");
                          } else if (type === "failed") {
                            setModelType("show_failed");
                          }
                        }}
                      />
                    </Elements>
                  )}
                </div>
              </div>
            ) : (
              !showLoader &&
              showError && (
                <div className="d-flex align-items-center justify-content-center">
                  <div className="text-center">
                    <h2
                      style={{ color: "#54aad6" }}
                      className="text-2xl font-bold mb-2 text-gray-800"
                    >
                      Successful!
                    </h2>
                    <CheckCircle
                      style={{
                        color: "#54aad6",
                        width: "40px",
                        height: "40px",
                      }}
                      className="mx-auto mb-3"
                    />
                    <p className="text-gray-600 mb-6">{showError}</p>
                  </div>
                </div>
              )
            )}
            {!showLoader &&
              confirmationData &&
              Object.entries(confirmationData)?.length > 0 && (
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <Button
                    className="submit_button"
                    onClick={() => {
                      handleGetStarted("paid", confirmationData);
                    }}
                  >
                    Yes, Start Plan
                  </Button>
                </div>
              )}
          </Modal.Body>
        </Modal>
      )}

      {modelType === "show_success" && (
        <Modal
          id="join-modal"
          className="custom-modal1 custom-modal2 custom-modal3"
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header style={{ marginBottom: "2px" }}>
            <i
              className="fa-solid fa-xmark"
              onClick={() => {
                setModelType("");
                props.onCloseHitApi();
              }}
            ></i>
          </Modal.Header>
          <div className="d-flex align-items-center justify-content-center">
            <div className="text-center">
              <h2
                style={{ color: "#54aad6" }}
                className="text-2xl font-bold mb-2 text-gray-800"
              >
                Payment Successful!
              </h2>
              <CheckCircle
                style={{ color: "#54aad6", width: "40px", height: "40px" }}
                className="mx-auto mb-3"
              />
              <p className="text-gray-600 mb-6">
                Thank you for subscribing. Your payment was processed
                successfully.
              </p>
            </div>
          </div>

          <Modal.Body className="mt-2"></Modal.Body>
        </Modal>
      )}

      {modelType === "show_failed" && (
        <Modal
          id="join-modal"
          className="custom-modal1 custom-modal2 custom-modal3"
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header style={{ marginBottom: "2px" }}>
            <i
              className="fa-solid fa-xmark"
              onClick={() => {
                setModelType("");
                props.onCloseHitApi();
              }}
            ></i>
          </Modal.Header>
          <div className="d-flex align-items-center justify-content-center">
            <div className="text-center">
              <h2
                style={{ color: "#e74c3c" }}
                className="text-2xl font-bold mb-2 text-gray-800"
              >
                Payment Failed!
              </h2>
              <XCircle
                style={{ color: "#e74c3c", width: "40px", height: "40px" }}
                className="mx-auto mb-3"
              />
              <p className="text-gray-600 mb-6">
                Oops! Something went wrong during the payment process.
              </p>
            </div>
          </div>
          <Modal.Body className="mt-2"></Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default PricingModal;
